<template>
  <div>
    <div class="lp-menu-item"
         @click="vChild?vChild=false:vChild=true">{{ item.text }}
    </div>
    <div class="lp-menu-child"
         :class="{'selected':selection(child.link)}"
         v-if="vChild"
         v-for="(child,idx) in item.child"
         :key="'child-'+idx"
         @click="clickChild(child)">
      {{ child.text }}
      <!-- <div class="lp-menu-grandchild" v-if="child.child" v-for="child in item.child.child">{{ child.text}}</div> -->
      <div v-if="child.child !== undefined">
        <div class="lp-menu-child" :class="{'selected':selection(gchild.link)}" v-if="vChild"
             v-for="gchild,gchild_idx in child.child"
             :key="'gchild-'+gchild_idx"
             @click.stop.prevent="clickChild(gchild)">
          {{ gchild.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props:['item'],
    created() {
      this.openMenu(this.$route);
    },
    data () {
      return {
        vChild: false,
        // vGchild: false,
        selLink: ''
      }
    },
    watch: {
      $route(n) {
        this.openMenu(n);
      }
    },
    methods: {
      openMenu(n) {
        if(this.item.child === undefined) return;

        var visible = false;
        for (var i = 0; i < this.item.child.length; i++){
          if (n.path === this.item.child[i].link) {
            visible = true;
          }
        }
        if(!visible) this.vChild = false;
        else this.vChild = true;
      },
      clickChild(child) {
        this.selLink = child.link;
        this.$router.push(child.link);
        this.$emit('visible')
      },
      selection(link) {
        if(link == this.$route.path.replace('/','')) return true;
        else return false;
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
//@import '~assets/css/lp_main'
  .lp-menu-item
  .lp-menu-child
    padding 16px 20px
    padding-right 12px
    cursor pointer

  .lp-menu-item
    color white
    border-top 1px solid white
    background-color $primary

  .lp-menu-child
    background-color white
    color $darkgrey
    padding-left 28px
    border-bottom 1px solid #ddd

  .lp-menu-child:last-child
    border-bottom 0

  .lp-menu-child:hover
  .selected
    color $primary

</style>
